<template>
  <div class="students-page">
    <div class="out d-flex flex-column">
      <header-secondary
        :fullHeader="true"
        :containerFluid="false"
        title="Студентам"
      ></header-secondary>
      <main class="simple-page flex-grow-1">
        <section class="section">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-md-12">
                <p>
                  Придумать текст описание зачем это все
                  <a href="/">link</a>
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer gray="section--gray" />
    </div>
  </div>
</template>

<script>
import HeaderSecondary from '@/components/HeaderSecondary.vue';
import Footer from '@/components/Footer.vue';
import msg from '@/utils/messages';

export default {
  name: 'Home',
  components: {
    HeaderSecondary,
    Footer
  },
  metaInfo() {
    return {
      title: msg.PAGE_TITLE_STUDENTS,
      titleTemplate: `${this.siteName || ''} - %s`
    };
  },
  computed: {
    siteName() {
      return this.$store.getters.getSiteParams?.siteName;
    }
  }
};
</script>
